import api from '../../../utils/api';
import { alertError } from '../alert';
import { WOOCOMMERCE_CUSTOMER_ID } from '../../constants/woocommerceTypes';

export const createWoocommerceCustomerAccount = (userName, supplierId, retailerId) => async (dispatch) => {
  try {
    const res = await api.post('/woocommerce/create-woocommerce-customer-user', {
      username: userName,
      retailer_id: retailerId,
      supplier_id: supplierId,
    });
    if (res.data.id) {
      const wooCommerceCustomerAccountId = res.data.username.toString();
      dispatch({
        type: WOOCOMMERCE_CUSTOMER_ID,
        payload: { woocommerceCustomerAccountId: wooCommerceCustomerAccountId },
      });
    } else dispatch(alertError({ message: 'Failed to create a Woocommerce customer account' }));
  } catch (e) {
    dispatch(alertError(e));
  }
};
